export default {
  future: '%s',
  past: '%s ezelőtt',
  s: 'néhány másodperc',
  ss: '%d másodpercek',
  m: 'egy perc',
  mm: '%d perc',
  h: 'egy óra',
  hh: '%d óra',
  d: 'egy nap',
  dd: '%d nap',
  M: 'egy hónap',
  MM: '%d hónap',
  y: 'egy év',
  yy: '%d év'
};
